import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";
import { ESTADOS_PRODUCCION } from "../../../../../../../../../utility/constants";
import { ActionsContent } from "./ActionsContent";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const ProduccionesTable = ({
    producciones,
    EliminarProduccion,
    estado,
    setProduccionSeleccionada,
}) => {
    return (
        <div className="new-table-wrapper producciones__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>No. Producción</th>
                        <th>Semana</th>
                        <th>Fecha Inicial</th>
                        <th>Producto(s)</th>
                        <th>Kg a producir</th>
                        {estado !== ESTADOS_PRODUCCION.PENDIENTE && (
                            <React.Fragment>
                                <th>Kg producidos</th>
                                <th>Kg pendientes</th>
                            </React.Fragment>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {producciones.length === 0 && (
                        <tr>
                            <td colSpan={estado !== ESTADOS_PRODUCCION.PENDIENTE ? 8 : 6} className="text-center">
                                No hay registros de producción
                            </td>
                        </tr>
                    )}
                    {producciones.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td>
                                    <ActionsContent
                                        estado={estado}
                                        item={item}
                                        setProduccionSeleccionada={
                                            setProduccionSeleccionada
                                        }
                                        EliminarProduccion={EliminarProduccion}
                                    />
                                </td>

                                <td className="text-center">{item.numero}</td>
                                <td className="text-center text-nowrap">
                                    Semana {item.semana}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_inicial
                                        ? moment(item.fecha_inicial).format(
                                              "DD/MM/YYYY",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.productos || "—"}
                                </td>
                                <td className="text-center text-nowrap producciones__table-ellipsis-cell">
                                    <RenderKilogramo
                                        value={item.kg_a_producir}
                                        decimals={2}
                                    />
                                </td>
                                {estado !== ESTADOS_PRODUCCION.PENDIENTE && (
                                    <React.Fragment>
                                        <td className="text-center text-nowrap">
                                            <RenderKilogramo
                                                value={item.kg_paletizados || 0}
                                                decimals={2}
                                            />
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <RenderKilogramo
                                                value={item.kg_pendientes || 0}
                                                decimals={2}
                                            />
                                        </td>
                                    </React.Fragment>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
